
      const intercomAppId = import.meta.env.VITE_APP_INTERCOM_APP_ID;

      if (intercomAppId) {
        (function () {
          var w = window;
          var ic = w.Intercom;
          if (typeof ic === 'function') {
            ic('reattach_activator');
          } else {
            var i = function () {
              i.c(arguments);
            };
            i.q = [];
            i.c = function (args) {
              i.q.push(args);
            };
            w.Intercom = i;
          }
        })();

        const s = document.createElement('script');
        s.id = 'intercom-script';
        s.async = true;
        s.defer = true;
        s.src = `https://widget.intercom.io/widget/${intercomAppId}`;
        document.head.appendChild(s);
      }
    